<template>
  <div class="card-cell">
    <div class="card-hd" @click="goHome(cardTitle)">{{cardTitle}}</div>
    <div class="card-bd">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShoppingCartCard',

  props: {
    cardTitle: {
      type: String,
      default: '超凡娱乐'
    }
  },
  methods: {
    goHome (val) {
      if (val === '免税店') {
        this.$router.push('/ductyfree')
      } else if (val === '日妆店') {
        this.$router.push('/cosmetic')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.card-cell{
  padding-bottom: 0px;
  min-height: 200px;
  margin-bottom: 20px;
}
</style>
